export const WHY_CLEARBIT = "WHY_CLEARBIT";
export const PRODUCTS = 'PRODUCTS'
export const SOLUTIONS = 'SOLUTIONS'